import { Tutorial } from 'app/types/tutorial';
import { HOME_EXPLORE_TUTORIAL_TOTAL_STEPS } from './home-explore-tutorial';

const TUTORIAL_STEP_COUNTS: Record<Tutorial, number> = {
  [Tutorial.PublishOffers]: 5,
  [Tutorial.MultipleOffers]: 1,
  [Tutorial.ChatCreation]: 1,
  [Tutorial.FirstConversation]: 1,
  [Tutorial.FirstMessageSent]: 1,
  [Tutorial.Conciergerie]: 1,
  [Tutorial.HomeExplore]: HOME_EXPLORE_TUTORIAL_TOTAL_STEPS,
  [Tutorial.ContactMember]: 1,
  [Tutorial.ChatIntro]: 2,
  [Tutorial.Guardian]: 1,
};

export function getTutorialStepCount(tutorial: Tutorial): number {
  return TUTORIAL_STEP_COUNTS[tutorial];
}
